<a class="videoLink1" #fileInput data-bs-toggle="modal" data-bs-target="#myModal" [hidden]="isIconHide"
  (click)="IsvideoActive(true);">
  <span class="watch-video-text">{{ 'label_watch_video' | translate:param }}</span>
  <img src="assets/svg-icons/new-video-icon.svg" alt="" class="watch-video-img">
</a>

<div class="clear"></div>

<div (click)="afterHidden(false)" class="modal fade z-99999 blured-overLay" id="myModal" tabindex="-1" role="dialog"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document" style="max-width: 970px;  margin: 1.75rem auto;">
    <div class="modal-content">
      <div class="modal-header">
        <button style="background-color: transparent !important" type="button" class="close" data-bs-dismiss="modal"
          aria-label="Close" (click)="close(false);"><span aria-hidden="true"
            class="video-close">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="show-iframe-loader" *ngIf="showLoading">
        </div>
        <div [class.d-none]="showLoading" style="background:white;width:100%;margin:auto;"><iframe [src]='VideoUrl'
            referrerpolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            (load)="onLoad()" width="100%" height="450px" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen [className]="this.setClass"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>